import { render, staticRenderFns } from "./EditAdditionalSection.vue?vue&type=template&id=e38db5c6&scoped=true&"
import script from "./EditAdditionalSection.vue?vue&type=script&lang=js&"
export * from "./EditAdditionalSection.vue?vue&type=script&lang=js&"
import style0 from "./EditAdditionalSection.vue?vue&type=style&index=0&id=e38db5c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e38db5c6",
  null
  
)

export default component.exports